/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import LoginContent from '../../Contents/LoginContent/LoginContent';

import {
  Box,
  Card,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { cardStyles, cardWrapperStyles } from './styles';
import LogoRMF from '../../../../assets/images/fullLogo.png';
import { TwoAuthContent } from '../../Contents/TwoAuthContent/TwoAuthContent';

const Login = () => {
  const { t } = useTranslation('login');
  const theme = useTheme();

  const [isTwoFactorRequired, setIsTwoFactorRequired] = useState(false);
  const [twoFactorContext, setTwoFactorContext] = React.useState<{
  email: string;
  rememberMe: boolean;
} | null>(null);
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Blur violets / bleus de fond */}
      <Box
        sx={{
          height: '400px',
          width: '400px',
          position: 'absolute',
          bottom: '-150px',
          right: '-150px',
          backgroundColor: '#A855F7',
          filter: 'blur(300px)',
          opacity: 0.5,
        }}
      />
      <Box
        sx={{
          height: '400px',
          width: '400px',
          position: 'absolute',
          top: '-150px',
          left: '-150px',
          backgroundColor: '#3B82F6',
          filter: 'blur(300px)',
          opacity: 0.5,
        }}
      />

      <Stack css={cardWrapperStyles}>
        {isTwoFactorRequired && twoFactorContext  ? (
          <TwoAuthContent email={twoFactorContext.email} rememberMe={twoFactorContext.rememberMe}/>
        ) : (
          <Card elevation={0} css={cardStyles}>
            <Box
              component={'img'}
              src={LogoRMF}
              width={'auto'}
              height={'100px'}
              sx={{ display: 'block', mb: 4 }}
            />

            <Typography
              variant="h4"
              align="center"
              sx={{ mt: 1, mb: 1, fontWeight: 600 }}
            >
              {t('TITLE_LOG_IN_TO_RAISEMYFUNDS')}
            </Typography>

            <Typography variant="body1" align="center">
              {t('DONT_HAVE_PROFILE_YET')}{' '}
              <Link
                to="/buy-challenge"
                style={{
                  textDecoration: 'underline',
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                }}
              >
                {t('BUY_YOUR_FIRST_CHALLENGE')}
              </Link>
            </Typography>

            {/* Formulaire email / mot de passe */}
            <LoginContent 
              onTwoFactorRequired={(email, rememberMe) => {
                setTwoFactorContext({ email, rememberMe });
                setIsTwoFactorRequired(true);
              }}
            />
          </Card>
        )}
      </Stack>
    </Box>
  );
};

export default Login;
